import React from "react";
import {
    BarChart,
    Bar,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    ResponsiveContainer,
} from "recharts";

const mockData = [
    { name: "Ene", value1: 0, value2: 0 },
    { name: "Feb", value1: 0, value2: 0 },
    { name: "Mar", value1: 0, value2: 0 },
    { name: "Abr", value1: 0, value2: 0 },
    { name: "May", value1: 0, value2: 0 },
    { name: "Jun", value1: 0, value2: 0 },
    { name: "Jul", value1: 0, value2: 0 },
    { name: "Ago", value1: 2000, value2: 1000 },
    { name: "Sep", value1: 10000, value2: 25000 },
    { name: "Oct", value1: 0, value2: 0 },
    { name: "Nov", value1: 0, value2: 0 },
    { name: "Dic", value1: 0, value2: 0 },
];

const ComparisonBarChart = ({
    data = mockData,
    colors = ["#8FCDFF", "#6FB75D"],
    height = 260,
    seriesKeys = ["value1", "value2"],
    seriesLabels = ["Serie A", "Serie B"],
    showLines = true,
}) => {
    const CustomTooltip = ({ active, payload, label }) => {
        if (active && payload && payload.length) {
            return (
                <div
                    style={{
                        border: "1px solid #e5e7eb",
                        borderRadius: "15px",
                        padding: "1em",
                        boxShadow: "0px 2px 8px rgba(0,0,0,0.1)",
                        fontSize: "12px",
                        color: "#394F65",
                        background: "#fff",
                    }}
                >
                    <p style={{ margin: 0, fontWeight: 600 }}>{label}</p>
                    {payload.map((entry, index) => (
                        <p key={`item-${index}`} style={{ margin: 0, color: entry.color }}>
                            {`${seriesLabels[index] || entry.name}: $${entry.value.toLocaleString()}`}
                        </p>
                    ))}
                </div>
            );
        }
        return null;
    };

    return (
        <ResponsiveContainer width="100%" height={height}>
            <BarChart data={data} barGap={5}>
                {showLines && (
                    <CartesianGrid strokeDasharray="3 3" vertical={false} />
                )}
                <XAxis
                    dataKey="name"
                    axisLine={showLines}
                    tickLine={false}
                    stroke="rgba(0, 0, 0, 0.40)"
                    tick={{
                        fill: "rgba(0, 0, 0, 0.40)",
                        fontSize: "15px",
                        fontWeight: 400,
                    }}
                />
                <YAxis
                    axisLine={showLines}
                    tickLine={false}
                    stroke="rgba(0, 0, 0, 0.40)"
                    tickFormatter={(value) => `${value / 1000}K`}
                    tick={{
                        fill: "rgba(0, 0, 0, 0.40)",
                        fontSize: "15px",
                        fontWeight: 400,
                    }}
                />
                <Tooltip content={<CustomTooltip />} />
                <Bar dataKey={seriesKeys[0]} fill={colors[0]} radius={[4, 4, 0, 0]} />
                <Bar dataKey={seriesKeys[1]} fill={colors[1]} radius={[4, 4, 0, 0]} />
            </BarChart>
        </ResponsiveContainer>
    );
};

export default ComparisonBarChart;
